import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Response } from "src/app/shared/models/Response";
import { Observable } from "rxjs";
import { PagedResponse } from "../shared/models/PagedResponse";
import { Page } from "../shared/models/Page";
import { CesionarioFilter } from "../models/Cesion/CesionarioFilter";
import { RespuestaBackend } from "../shared/models/RespuestaBackend";
import { Cesionario } from "../models/Cesion/Cesionario";
import { ActividadEconomica } from "../models/ActividadEconomica";

@Injectable({
   providedIn: "root",
})
export class CesionarioService {
   private REST_API_SERVER = environment.backend_server + "/Cesionario";
   private auth = {};
   constructor(private http: HttpClient) {}

   public getDataByPage(filtro: CesionarioFilter, page: Page): Observable<PagedResponse<Cesionario>> {
      return this.http.get<PagedResponse<Cesionario>>(this.REST_API_SERVER + "/list/filter?RazonSocial=" + (filtro.razonSocial != undefined ? filtro.razonSocial : "") + "&Rut=" + (filtro.rut != undefined ? filtro.rut : "") + "&Direccion=" + (filtro.direccion != undefined ? filtro.direccion : "") + "&EmisorId=" + (filtro.emisorId != undefined ? filtro.emisorId : "") + "&Activo=" + filtro.activo + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize);
   }

   deactivateCesionario(idCesionario: string): Observable<Response<boolean>> {
      return this.http.get<Response<boolean>>(this.REST_API_SERVER + "/deactivate/" + idCesionario);
   }

   activateCesionario(idCesionario: string): Observable<Response<boolean>> {
      return this.http.get<Response<boolean>>(this.REST_API_SERVER + "/activate/" + idCesionario);
   }

   updateCesionario(Cesionario: Cesionario): Observable<Response<Cesionario>> {
      return this.http.post<Response<Cesionario>>(this.REST_API_SERVER + "/update", Cesionario);
   }

   addCesionario(ent: Cesionario): Observable<Response<Cesionario>> {
      return this.http.post<Response<Cesionario>>(this.REST_API_SERVER + "/add", ent);
   }

   searchCesionario(pattern: string, emisorId: string): Observable<Response<Cesionario[]>> {
      return this.http.get<Response<Cesionario[]>>(this.REST_API_SERVER + "/buscar?pattern=" + pattern + "&emisorId=" + emisorId);
   }
}
